import { Component, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
export interface VersionItem {
  id: string;
  name: string;
  version: string;
  datetime?: string;
  origin?: string;
  download_url?: string;
  updated_at?: string;
}

@Component({
  selector: 'app-version-history-modal',
  templateUrl: './version-history-modal.component.html',
  styleUrls: ['./version-history-modal.component.scss'],
})
export class VersionHistoryModalComponent implements OnChanges {
  @Input() versions: VersionItem[] = [];
  @Input() allowEdit = true;
  @Input() isLoading = true;
  @Input() removeCallback?: (version: VersionItem) => void;
  @Output() dataChanged = new EventEmitter<any>();
  @Output() downloadVersion = new EventEmitter<VersionItem>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnChanges(changes: SimpleChanges) {
  }

  formatDatetime(datetime?: string): string {
    if (!datetime) return '—';
    const date = new Date(datetime);
    return date.toLocaleString();
  }

  async onDownload(version: VersionItem) {
    this.isLoading = true
    this.versions.length = 0
    this.dataChanged.emit({ action: 'download', version });
  }

  onEdit(version: VersionItem) {
    this.dataChanged.emit({ action: 'edit', version });
  }

  onRemove(version: VersionItem) {
    if (this.removeCallback) {
      try { this.removeCallback(version); } catch (e) { console.error('removeCallback error', e); }
    }
  }
sortField: string = '';
sortDirection: 'asc' | 'desc' = 'asc';

sort(field: string) {
  if (this.sortField === field) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortField = field;
    this.sortDirection = 'asc';
  }

  this.versions.sort((a, b) => {
    let valueA = a[field];
    let valueB = b[field];

    if (field === 'created_at') {
      valueA = new Date(valueA);
      valueB = new Date(valueB);
    }

    if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
    if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
}
  onClose() {
    this.activeModal.dismiss('closed');
  }
}
